webpackJsonp([7],{

/***/ 14:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(0);
__webpack_require__(15);
__webpack_require__(1);
module.exports = __webpack_require__(16);


/***/ }),

/***/ 15:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 16:
/***/ (function(module, exports) {

﻿var headerCount = 0;
var ads;

$(window).scroll(function () {
    // scrollTop是浏览器滚动条的top位置，
    var scrollTop = document.documentElement.scrollTop || document.body.scrollTop;
    var overHeight = $('.home-top-ads').height();
});

window.slideTimer = function () {
    $('.nav-arrow-next').click();
};

window.scrollTimer = function () {
    if (headerCount == 0) return;

    $('.home-scroll-roll').animate({ top: '-188px' }, 1000, 'swing', function () {
        $('.home-scroll-roll').css({ top: '0' });
        $('.home-scroll-roll').append($('.home-scroll-roll .home-scroll-block:first'));
    });
};

window.adTimer = function () {
    // var left = parseInt($('.home-in-ads-roll').css('left'));
    // if (1110 * (count - 1) + left == 0) {
    //     $('.home-in-ads-roll').css('left', 0);
    //     left = 0;
    // }
    // left -= 1110;
    // $('.home-in-ads-roll').animate({ left: left + 'px' });

    if ($('.top-ads .top-ads-navs .top-ads-nav').length > 1) {
        var index = $('.top-ads-nav.active').data('index');
        index = parseInt(index);
        index = index + 1 < $('.top-ads .top-ads-navs .top-ads-nav').length ? index + 1 : 0;
        $('.top-ads .top-ads-navs .top-ads-nav').removeClass('active');
        $('.top-ads .top-ads-navs .top-ads-nav[data-index=' + index + ']').addClass('active');

        $('.top-ads-scroll').animate({ top: '-296px' }, 1000, 'swing', function () {
            $('.top-ads-scroll').css({ top: '0' });
            $('.top-ads-scroll').append($('.top-ads-scroll .home-top-ad:first'));
        });
    }
};

window.hostTimer = function () {
    $('.host-scroll').animate({ left: '-142px' }, 1000, 'swing', function () {
        $('.host-scroll').css({ left: '0' });
        $('.host-scroll').append($('.host-scroll .host-item:first'));
    });
};

$(function () {
    var qrcode = new QRCode(document.getElementsByClassName('top-code')[1], {
        width: 124,
        height: 124
    });
    var url = $('.top-code').data('url');
    qrcode.makeCode(url);

    getSlides();
    getColumns();
    getNewest();
    getHottest();

    ads = getPositionAds(['home-top', 'home-in', 'home-in2', 'ALLBG'].toString());
    if (ads) {
        if (ads['ALLBG']) {
            var result = ads['ALLBG'];
            $('body').css({
                background: 'url(' + result.ads[0].picture_url + ')',
                backgroundRepeat: 'no-repeat',
                backgroundAttachment: 'fixed',
                backgroundPosition: 'center 0px'
            });

            $('.content').css({
                background: '#fff',
                boxSizing: 'content-box',
                padding: '0 25px',
                marginTop: '420px'
            });

            $('.top').css('backgroundColor','transparent');
            $('.home-in-ads.a0').remove();
        } else {
            if (ads['home-top'] && ads['home-top'].ads.length > 0) {
                var html = '';
                var navHtml = '';
                for (var i = 0; i < ads['home-top'].ads.length; i++) {
                    html += '<a class="home-top-ad" href="' + ads['home-top'].ads[i].link_url + '"';
                    html += ' style="background-image: url(' + ads['home-top'].ads[i].picture_url + ');"></a>';

                    navHtml += '<div class="top-ads-nav" data-index="' + i + '"></div>';
                }
                $('.top-ads .top-ads-list .top-ads-scroll').html(html);
                $('.top-ads .top-ads-navs').html(navHtml);
                $('.top-ads .top-ads-navs .top-ads-nav').eq(0).addClass('active');

                $('.no-ads .top').css('display', 'none');
                $('.top-ads').css('display', 'block');
            }
        }

        if (ads['home-in'] && ads['home-in'].ads.length > 0) {
            var html = '';
            html += '<a class="home-in-ad" href="' + ads['home-in'].ads[0].link_url + '">';
            html += '<img src="' + ads['home-in'].ads[0].picture_url + '?w=1110&h=90&s=2" />';
            html += '</a>';
            $('.home-in-ads.a1 .home-in-ads-roll').html(html);
        } else {
            $('.home-in-ads.a1').css('display', 'none');
        }
        if (ads['home-in2'] && ads['home-in2'].ads.length > 0) {
            var html = '';
            html += '<a class="home-in-ad" href="' + ads['home-in2'].ads[0].link_url + '">';
            html += '<img src="' + ads['home-in2'].ads[0].picture_url + '?w=1110&h=90&s=2" />';
            html += '</a>';
            $('.home-in-ads.a2 .home-in-ads-roll').html(html);
        } else {
            $('.home-in-ads.a2').css('display', 'none');
        }
    }

    var scrollInt = setInterval('scrollTimer()', 6000);

    var adInt = setInterval('adTimer()', 6000);

    var int = setInterval('slideTimer()', 6000);// 1000为1秒钟

    $('.slide-list').on('mouseover', function () {
        window.clearInterval(int);
    });

    $('.slide-list').on('mouseout', function () {
        int = setInterval('slideTimer()', 6000);// 1000为1秒钟
    });
});

function getSlides() {
    var data = getColumnList('slider', 1, 5);
    if (!data || !data.data || data.data.length == 0) {
        return;
    }
    var count = data.data.length > 5 ? 5 : data.data.length;
    var newlist = '';
    for (var i = 0; i < count; i++) {
        var info = data.data[i];
        if (i == 0)
            newlist += '<div class="slide-item current" data-index="' + i + '">';
        else
            newlist += '<div class="slide-item" data-index="' + i + '">';
        newlist += '<a href="' + info.url + '" target="_blank">';
        if (info.thumbnail_urls.length > 0)
            newlist += '<img src="' + info.thumbnail_urls[0] + '?w=660&h=342&s=3" />';
        else
            newlist += '<img src="" />';
        newlist += '<p>' + info.title + '</p>';
        newlist += '</a>';
        newlist += '</div>';
    }

    $('.slide-list .slide-items').append(newlist);
    for (var i = count; i < 5; i++) {
        $($('#nav-dots span')[i]).css('display', 'none');
    }
    var width = count > 0 ? 100 / parseInt(count) : 100;
    $('#nav-dots span').css('width', width + '%');
}

function getColumns() {
    var html = '';
    var newest = getColumnList('newest', 1, 5);
    if (newest && newest.data) {
        for (var i = 0; i < newest.data.length; i++) {
            var info = newest.data[i];

            html += '<div class="home-column-item">';
            html += '<a href="' + info.url + '" target="_blank">' + info.title + '</a>';
            html += '<div class="home-column-time">' + info.publish_time + '</div>';
            html += '</div>';
        }
        $('.home-column.newest .home-column-list').html(html);
    }

    html = '';
    var qx = getColumnList('DBZQ');
    if (qx && qx.data) {
        if (qx.data[0]) {
            html += '<a href="' + qx.data[0].url + '" target="_blank">';
            html += '<div class="home-column-img"><img src="' + qx.data[0].thumbnail_urls[0] + '?w=300&h=172&s=3" /></div>';
            html += '</a>';
        }
        if (qx.data[1]) {
            html += '<a href="' + qx.data[1].url + '" target="_blank">';
            html += '<div class="home-column-img"><img src="' + qx.data[1].thumbnail_urls[0] + '?w=300&h=172&s=3" /></div>';
            html += '</a>';
        }
        for (var i = 0; i < qx.data.length; i++) {
            var info = qx.data[i];
            if (i == 0 || i == 1) {
                html += '<div class="home-column-item black">';
            } else {
                html += '<div class="home-column-item">';
            }
            html += '<a href="' + info.url + '" target="_blank">' + info.title + '</a>';
            html += '</div>';
        }
        $('.home-column.qx .home-column-list').html(html);
    }

    html = '';
    var jx = getColumnList('list');
    if (jx && jx.data) {
        if (jx.data[0]) {
            html += '<a href="' + jx.data[0].url + '" target="_blank">';
            html += '<div class="home-column-img home-video">';
            html += '<img src="' + jx.data[0].thumbnail_urls[0] + '?w=300&h=172&s=3" />';
            html += '<div class="play-icon-bk"><div class="play-icon"></div></div>';
            html += '</div>';
            html += '</a>';
        }
        if (jx.data[1]) {
            html += '<a href="' + jx.data[1].url + '" target="_blank">';
            html += '<div class="home-column-img home-video">';
            html += '<img src="' + jx.data[1].thumbnail_urls[0] + '?w=300&h=172&s=3" />';
            html += '<div class="play-icon-bk"><div class="play-icon"></div></div>';
            html += '</div>';
            html += '</a>';
        }
        for (var i = 0; i < jx.data.length; i++) {
            var info = jx.data[i];
            if (i == 0 || i == 1) {
                html += '<div class="home-column-item black">';
            } else {
                html += '<div class="home-column-item">';
            }
            html += '<a href="' + info.url + '" target="_blank">' + info.title + '</a>';
            html += '</div>';
        }
        $('.home-column.JX .home-column-list').html(html);
    }

    html = '';
    var dsdb = getColumnList('qx', 1, 9);
    if (dsdb && dsdb.data) {
        for (var i = 0; i < dsdb.data.length; i++) {
            var info = dsdb.data[i];
            html += '<div class="dsdb-item">';
            html += '<a class="dsdb-item-img home-video" href="' + info.url + '" target="_blank">';
            if (i == 0) {
                html += '<img src="' + dsdb.data[i].thumbnail_urls[0] + '?w=302&h=200&s=3" />';
            } else {
                html += '<img src="' + dsdb.data[i].thumbnail_urls[0] + '?w=166&h=100&s=3" />';
            }
            html += '<div class="play-icon-bk"><div class="play-icon"></div></div>';
            html += '</a>';
            html += '<a href="' + info.url + '" target="_blank">' + info.title + '</a>';
            html += '</div>';
        }
        $('.home-column.dsdb .home-column-list').html(html);
    }

    // html = '';
    // var XCJR = getColumnList('XCJR');
    // if (XCJR && XCJR.data) {
    //     if (XCJR.data[0]) {
    //         html += '<a href="' + XCJR.data[0].url + '" target="_blank">';
    //         html += '<div class="home-column-img home-video">';
    //         html += '<img src="' + XCJR.data[0].thumbnail_urls[0] + '?w=300&h=172&s=3" />';
    //         html += '<div class="play-icon-bk"><div class="play-icon"></div></div>';
    //         html += '</div>';
    //         html += '</a>';
    //     }
    //     if (XCJR.data[1]) {
    //         html += '<a href="' + XCJR.data[1].url + '" target="_blank">';
    //         html += '<div class="home-column-img home-video">';
    //         html += '<img src="' + XCJR.data[1].thumbnail_urls[0] + '?w=300&h=172&s=3" />';
    //         html += '<div class="play-icon-bk"><div class="play-icon"></div></div>';
    //         html += '</div>';
    //         html += '</a>';
    //     }
    //     if (XCJR.data[2]) {
    //         html += '<a href="' + XCJR.data[2].url + '" target="_blank">';
    //         html += '<div class="home-column-img home-video">';
    //         html += '<img src="' + XCJR.data[2].thumbnail_urls[0] + '?w=300&h=172&s=3" />';
    //         html += '<div class="play-icon-bk"><div class="play-icon"></div></div>';
    //         html += '</div>';
    //         html += '</a>';
    //     }
    //     // for (var i = 0; i < XCJR.data.length; i++) {
    //     //     var info = XCJR.data[i];
    //     //     if (i == 0 || i == 1 || i == 3) {
    //     //         html += '<div class="home-column-item black">';
    //     //     } else {
    //     //         html += '<div class="home-column-item">';
    //     //     }
    //     //     html += '<a href="' + info.url + '" target="_blank">' + info.title + '</a>';
    //     //     html += '</div>';
    //     // }
    //     $('.home-column.XCJR .home-column-list').html(html);
    // }
}

function getNewest() {
    $.ajax({
        type: 'get',
        async: false,
        url: '/home/newest',
        data: null,
        contentType: 'application/json',
        dataType: 'json',
        success: function (data) {
            if (data) {
                var html = '';
                for (var i = 0; i < data.length; i++) {
                    var info = data[i];

                    html += '<div class="home-recommend-item">';
                    html += '<a href="' + info.url + '" target="_blank">' + (i + 1) + '.' + info.title + '</a>';
                    html += '</div>';
                }
                $('.home-recommend.newest .home-recommend-list').html(html);
            }
        },
        error: function (data) {
            console.log(data);
        }
    });
}

function getHottest() {
    $.ajax({
        type: 'get',
        async: false,
        url: '/home/hottest',
        data: null,
        contentType: 'application/json',
        dataType: 'json',
        success: function (data) {
            if (data) {
                var html = '';
                for (var i = 0; i < data.length; i++) {
                    var info = data[i];

                    html += '<div class="home-recommend-item">';
                    html += '<a href="' + info.url + '" target="_blank">' + (i + 1) + '.' + info.title + '</a>';
                    html += '</div>';
                }
                $('.home-recommend.top10 .home-recommend-list').html(html);
            }
        },
        error: function (data) {
            console.log(data);
        }
    });
}


/***/ })

},[14]);


// WEBPACK FOOTER //
// js/home078945.js